import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import Adatvedelmi from "@/pages/Adatvedelmi";
import CookieSzabalyzat from "@/pages/CookieSzabalyzat";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/adatvedelmi" element={<Adatvedelmi />} />
        <Route path="/cookie-szabalyzat" element={<CookieSzabalyzat />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
